/* STO ALGO — theme scripts */
(function () {
  'use strict';

  /* ---------- Mobile navigation ---------- */
  function initMobileNav() {
    var toggle = document.querySelector('[data-sto-nav-toggle]');
    var nav = document.querySelector('[data-sto-mobile-nav]');
    if (!toggle || !nav) return;

    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
      document.body.style.overflow = open ? 'hidden' : '';
    });

    nav.addEventListener('click', function (event) {
      if (event.target.closest('a')) {
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      }
    });
  }

  /* ---------- Sticky header state ---------- */
  function initHeaderScroll() {
    var header = document.querySelector('[data-sto-header]');
    if (!header) return;

    var update = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 24);
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  /* ---------- FAQ accordion ---------- */
  function initAccordions() {
    document.querySelectorAll('[data-sto-accordion]').forEach(function (accordion) {
      accordion.addEventListener('click', function (event) {
        var trigger = event.target.closest('.sto-accordion__trigger');
        if (!trigger) return;

        var item = trigger.closest('.sto-accordion__item');
        var panel = document.getElementById(trigger.getAttribute('aria-controls'));
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';

        // close siblings
        accordion.querySelectorAll('.sto-accordion__item').forEach(function (other) {
          if (other === item) return;
          other.classList.remove('is-open');
          var otherTrigger = other.querySelector('.sto-accordion__trigger');
          var otherPanel = other.querySelector('.sto-accordion__panel');
          if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
          if (otherPanel) {
            otherPanel.style.height = '';
            otherPanel.hidden = true;
          }
        });

        if (isOpen) {
          trigger.setAttribute('aria-expanded', 'false');
          item.classList.remove('is-open');
          collapse(panel);
        } else {
          trigger.setAttribute('aria-expanded', 'true');
          item.classList.add('is-open');
          expand(panel);
        }
      });
    });
  }

  function expand(panel) {
    if (!panel) return;
    panel.hidden = false;
    var height = panel.scrollHeight;
    panel.style.height = '0px';
    requestAnimationFrame(function () {
      panel.style.transition = 'height 0.3s ease';
      panel.style.height = height + 'px';
    });
    panel.addEventListener('transitionend', function handler() {
      panel.style.height = 'auto';
      panel.style.transition = '';
      panel.removeEventListener('transitionend', handler);
    });
  }

  function collapse(panel) {
    if (!panel) return;
    panel.style.height = panel.scrollHeight + 'px';
    requestAnimationFrame(function () {
      panel.style.transition = 'height 0.25s ease';
      panel.style.height = '0px';
    });
    panel.addEventListener('transitionend', function handler() {
      panel.hidden = true;
      panel.style.height = '';
      panel.style.transition = '';
      panel.removeEventListener('transitionend', handler);
    });
  }

  /* ---------- Cart count refresh ---------- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (node) {
      node.textContent = count;
    });
  }

  function refreshCartCount() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (cart) { if (cart) updateCartCount(cart.item_count); })
      .catch(function () { /* silent */ });
  }

  /* ---------- Buy buttons (hero + pricing) ---------- */
  /* When "Buy Now goes straight to checkout" is on, the form posts natively with
     return_to=/checkout. Otherwise we add to cart via AJAX and stay on the page. */
  function initBuyForms() {
    document.querySelectorAll('[data-sto-buy-form]').forEach(function (form) {
      var goesToCheckout = !!form.querySelector('input[name="return_to"]');
      if (goesToCheckout) return;

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var button = form.querySelector('[data-sto-buy-submit]');
        var label = button ? button.querySelector('.sto-btn__label') : null;
        var loading = button ? button.querySelector('.sto-btn__loading') : null;

        if (button) {
          button.classList.add('is-loading');
          button.disabled = true;
          if (loading) loading.hidden = false;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            id: form.querySelector('[data-sto-variant-id]').value,
            quantity: 1
          })
        })
          .then(function (res) { return res.json(); })
          .then(function () {
            refreshCartCount();
            if (label) label.textContent = 'ADDED TO CART';
            setTimeout(function () {
              if (label) label.textContent = form.dataset.stoLabel || 'BUY NOW';
            }, 2200);
          })
          .catch(function () {
            if (label) label.textContent = 'TRY AGAIN';
          })
          .finally(function () {
            if (button) {
              button.classList.remove('is-loading');
              button.disabled = false;
              if (loading) loading.hidden = true;
            }
          });
      });
    });
  }

  /* ---------- Product page variant switching ---------- */
  function initVariantSelectors() {
    var form = document.querySelector('.sto-product__form');
    var dataEl = document.querySelector('[data-sto-variant-data]');
    if (!form || !dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var selectors = form.querySelectorAll('[data-sto-option-selector]');
    var idInput = form.querySelector('[data-sto-variant-id]');
    var submit = form.querySelector('[data-sto-add]');
    var priceEl = document.querySelector('[data-sto-price]');

    selectors.forEach(function (select) {
      select.addEventListener('change', function () {
        var chosen = Array.prototype.map.call(selectors, function (s) { return s.value; });
        var match = variants.find(function (variant) {
          return chosen.every(function (value, index) { return variant.options[index] === value; });
        });

        if (!match) {
          if (submit) {
            submit.disabled = true;
            submit.textContent = 'UNAVAILABLE';
          }
          return;
        }

        if (idInput) idInput.value = match.id;
        if (submit) {
          submit.disabled = !match.available;
          submit.textContent = match.available ? (submit.dataset.label || 'BUY NOW') : 'SOLD OUT';
        }
        if (priceEl && window.Shopify && typeof match.price === 'number') {
          priceEl.textContent = formatMoney(match.price);
        }

        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      });
    });
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var format = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
    return format ? amount + ' ' + format : '$' + amount;
  }

  /* ---------- Smooth anchor scrolling ---------- */
  function initAnchorScroll() {
    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[href^="#"]');
      if (!link) return;

      var id = link.getAttribute('href');
      if (!id || id === '#') return;

      var target = document.querySelector(id);
      if (!target) return;

      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      window.history.replaceState({}, '', id);
    });
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var targets = document.querySelectorAll(
      '.sto-feature-card, .sto-stat, .sto-testimonial, .sto-pricing__card, .sto-accordion__item, .sto-section-heading'
    );
    if (!targets.length || !('IntersectionObserver' in window)) return;

    targets.forEach(function (el) { el.classList.add('sto-reveal'); });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry, index) {
        if (!entry.isIntersecting) return;
        setTimeout(function () {
          entry.target.classList.add('is-visible');
        }, index * 70);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });

    targets.forEach(function (el) { observer.observe(el); });
  }

  /* ---------- Init ---------- */
  function init() {
    initMobileNav();
    initHeaderScroll();
    initAccordions();
    initBuyForms();
    initVariantSelectors();
    initAnchorScroll();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when sections are re-rendered in the Theme Editor
  document.addEventListener('shopify:section:load', init);
})();
